import { lazyInitializeAccountAndCalendars } from 'owa-calendar-bootstrap-utils';

let hasInitialized: boolean = false;

export default function initializeCalendars(): void {
    if (hasInitialized) {
        return;
    }

    hasInitialized = true;
    lazyInitializeAccountAndCalendars.importAndExecute();
}
